export default __webpack_public_path__ + "static/media/drag.524d7fe0.svg";